<template>
  <div>
    <v-text-field
      class="small-text-field"
      :required="required"
      :value="content"
      :label="label"
      :placeholder="placeholder"
      :height="28"
      flat
      filled
      :prepend-inner-icon="prependIcon"
      :maxlength="maxlength"
      :hide-details="valid() == true && (error == null || error.length == 0)"
      :error-messages="valid() == true ? null : [valid()] "
      :disabled="disabled"
      outlined
      dense
      @input="updateSelf"
      :style="{width: width}"
      @blur="blurNative"
    />
  </div>
</template>

<script>
export default {
  name: "SimpleTextInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: null
    },
    content: String,
    label: String,
    errorMessages: Object,
    prependIcon: { type: String, default: null },
    placeholder: { type: String, default: "" },
    maxlength: { type: Number, default: 1000 },
    error: String,
    width: String,
  },
  data() {
    return {
      menu: false,
      required: false
    };
  },
  computed: {},
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(content) {
      this.$emit("input", content);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    },
    blurNative() {
      this.$emit("blur", this.content);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
